(function () {
  const ROOT_SELECTOR = '[data-product-description-preview]';
  const CONTENT_SELECTOR = '[data-product-description-preview-content]';
  const TOGGLE_SELECTOR = '[data-product-description-preview-toggle]';
  const LABEL_SELECTOR = '[data-product-description-preview-label]';
  const DEFAULT_PREVIEW_RATIO = 0.15;
  const OVERFLOW_THRESHOLD = 24;

  function debounce(callback, delay) {
    let timer;
    return function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(callback, delay);
    };
  }

  function getLabel(toggle, expanded) {
    return expanded
      ? toggle.dataset.collapseLabel || '閉じる'
      : toggle.dataset.expandLabel || 'もっと見る';
  }


  function getPreviewRatio(root) {
    const ratio = Number(root.dataset.previewRatio);
    if (!Number.isFinite(ratio) || ratio <= 0) return DEFAULT_PREVIEW_RATIO;
    return Math.min(Math.max(ratio, 0.05), 0.8);
  }

  function setExpanded(root, expanded) {
    const content = root.querySelector(CONTENT_SELECTOR);
    const toggle = root.querySelector(TOGGLE_SELECTOR);
    const label = toggle && toggle.querySelector(LABEL_SELECTOR);

    if (!content || !toggle) return;

    root.classList.toggle('is-expanded', expanded);
    root.classList.toggle('is-collapsed', !expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (label) {
      label.textContent = getLabel(toggle, expanded);
    }

    content.style.maxHeight = expanded
      ? `${content.scrollHeight}px`
      : root.style.getPropertyValue('--product-description-preview-height');
  }

  function measure(root) {
    const content = root.querySelector(CONTENT_SELECTOR);
    const toggle = root.querySelector(TOGGLE_SELECTOR);

    if (!content || !toggle) return;

    content.style.maxHeight = 'none';
    const fullHeight = content.scrollHeight;
    const previewHeight = Math.round(fullHeight * getPreviewRatio(root));
    const isCollapsible = fullHeight - previewHeight > OVERFLOW_THRESHOLD;

    root.classList.toggle('is-collapsible', isCollapsible);

    if (!isCollapsible) {
      root.classList.remove('is-collapsed', 'is-expanded');
      root.style.removeProperty('--product-description-preview-height');
      toggle.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = 'none';
      return;
    }

    root.style.setProperty('--product-description-preview-height', `${previewHeight}px`);
    setExpanded(root, root.classList.contains('is-expanded'));
  }

  function initRoot(root) {
    const content = root.querySelector(CONTENT_SELECTOR);
    const toggle = root.querySelector(TOGGLE_SELECTOR);

    if (!content || !toggle) return;

    if (root.dataset.productDescriptionPreviewInitialized !== 'true') {
      root.dataset.productDescriptionPreviewInitialized = 'true';
      toggle.addEventListener('click', function () {
        setExpanded(root, toggle.getAttribute('aria-expanded') !== 'true');
      });

      const details = root.closest('details');
      if (details) {
        details.addEventListener('toggle', function () {
          if (details.open) {
            window.requestAnimationFrame(function () {
              measure(root);
            });
          }
        });
      }

      content.querySelectorAll('img').forEach(function (image) {
        if (!image.complete) {
          image.addEventListener('load', function () {
            measure(root);
          }, { once: true });
        }
      });
    }

    window.requestAnimationFrame(function () {
      measure(root);
    });
  }

  function initProductDescriptionPreviews(scope) {
    const container = scope || document;
    container.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  const refresh = debounce(function () {
    initProductDescriptionPreviews(document);
  }, 150);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductDescriptionPreviews(document);
    });
  } else {
    initProductDescriptionPreviews(document);
  }

  window.addEventListener('resize', refresh);
  document.addEventListener('shopify:section:load', function (event) {
    initProductDescriptionPreviews(event.target);
  });
})();
